<template class="">
  <div class="">
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>

    <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600&family=Source+Sans+Pro:wght@300&display=swap" rel="stylesheet">
    <link rel="stylesheet" href="https://use.fontawesome.come/releases/v5.4.1/css/all.css">
    
      <!-- homepage -->
      <div class="">
        <img class="hero_image" src="@/assets/homeProfile.png" alt="">
        
        <div class="hero_text ">
          <div class="light_underline">
            <h1 class="header light_colour">CLEMENTE GONZALES</h1>
            <h2 class="secondary_header light_colour">Web Developer</h2>
          </div>

          <div class="light_colour baseline space_between">
        
            <a href="#anchor-about"  class="aboutMe light_colour">About Me</a>

        
            <a href="#anchor-projects" class="aboutMe light_colour">My Projects</a>

         
            <a href="#anchor-contact" class="aboutMe light_colour">Contact Me</a>
            
          </div>
        </div>
      
      </div>
      
      
      <section class="background_divider row padding_md" id="anchor-about">

        <div  class="container_half  col-6 center margin_md">
          <div class="container_smaller">
            <h1  class="header light_colour light_underline">Clemente Gonzales</h1>

            <p class="light_colour about_me margin_xsm padding_sm">
              Ever since I was younger I have always been interested in creative work, 
              varying from fashion and clothes, to art, music, video editing and animation. 
              It was only inevitable that I would fall in love with designing and coding. 
            </p>
            
            <p class="light_colour about_me margin_xsm">
              Being a creative individual with a passion for creation, IADT has offered me plenty of opportunities to develop my creative 
              side and develop my understanding of design, 
              as well as my logical side through our coding courses. 
              I was able to better understand picking out anything that works well together, the fundamentals of design, as well as constantly 
              improve in what I create through the many projects that I have worked on. 
              There is a huge development improvement from my first project to my most recent
            </p>

            <p class="light_colour about_me margin_xsm">
              By doing personal projects, I challenged myself to discover or further explore topics that I have not yet attempted or the lecturer 
              has not discussed, all in order to further develop my comprehension of that coding language. I found that doing this has vastly improved 
              my problem solving abilities, arming me with many different methods to fix issues within my code.
            </p>

            <p class="light_colour about_me margin_xsm">
              I take pride in what I make, and I am always excited to learn something new. 
              I recently picked up animation, and digital art this year alone, and am planning to 
              learn even more during my spare time.
            </p>
            
            <p class="light_colour about_me margin_xsm">
              My passion for creation has only grown, and I am eager to work, and catch new opportunities to learn and improve my craft. 
              I’m excited to work with you!
            </p>

            <div class="margin_md display_flex center_me contact_margin">
              <a class="contact_button " href="#anchor-contact">Contact Me</a>
            </div>
            
          </div>
          
        </div>

        <section class="container_half dark_colour col-6 center margin_md">
          <div class="container_smaller">
            <h1 class="header  dark_underline">Skills</h1>
            <div class="skills">

              <div class="my_container padding_sm">
                <p class="frontend_underline">Front-End</p>
                <p>89%</p>
              </div>

              <div class="my_container padding_sm">
                <p class="backend_underline">Back-End</p>
                <p>65%</p>
              </div>

              <div class="my_container padding_sm">
                <p class="ui_underline">Ui Design</p>
                <p>75%</p>
              </div>

              <div class="padding_sm">
                <h3 class="skills_font">Front End</h3>
                <p class="skills_paragraph">Profecient in HTML, CSS, and JavaScript as well as different libraries and frameworks such as Bootstrap,
                  Material Design, Vue.js, and GSAP. I have a lot of experience with front-end development and have a variety of skills with building websites
                </p>
              </div>
              <div class="padding_sm">
                <h3 class="skills_font">Back-End</h3>
                <p class="skills_paragraph">This includes PHP, Java, Kotlin, and MySQL. I have a good understanding of the fundamentals of Computer Science
                   because of what I learn from my course, being a hybrid of design and comp-sci.

                </p>
                <p class="margin_xsm skills_paragraph">
                   I regularly work with databases, so I can create queries and requests from a local database and display it to a webpage.
                   I can fully implement C.R.U.D functionalities in the projects that I build 
                </p>
              </div>
              <div class="padding_sm">
                <h3 class="skills_font">Design</h3>
                <p class="skills_paragraph">The programs I'm familiar with are Adobe Photoshop, Illustrator, Premiere, Figma, Miro and Krita, with 
                  Figma and Miro being used for prototypes and wireframes, as well as to  research similar applications to decide what is the most 
                  user-friendly approach.
                </p>
                <p class="margin_xsm skills_paragraph">
                    I’m familiar with the fundamentals and the process of design, such as color theory, font-sizing, line spacing and contrasting fonts. 
                </p>
              </div>
              

            </div>
            
          </div>
          
        </section>
        
      </section>
      
      <section class="light_backgroud display_flex center" id="anchor-projects">
        <h1 class="padding_lg header dark_underline ">View My Work</h1>
      </section>


    <!-- Cards and view my work section -->
    <section class="light_backgroud padding_bot_lg" >
      <div class=" pad_left_right ">
        <section class="  row row-cols-2 g-2">
          <div class=" col-6 margin_md" v-for="project in filteredProjects"
            :key="project.id">
            <div class="">
              <figure class="">
                <img class="image_width_and_height fit_cover" v-if="project.images" :src="require(`@/assets/${project.images}`)" alt="Placeholder image">
              </figure>
            </div>
              <div class="background_dark card_width light_color " >
                <div class="">
                  <div class="">
                    <p class="card_header my_container center_me ">{{ project.title }}</p>
                      <div class="my_container card_description center_me">
                        {{ project.description}}
                      </div>
                    
                    <div class="my_container padding_xsm center_me">
                      <router-link class="my_button" v-if="project.demo" :to="{name: project.demo}" target="_blank">Demo</router-link>
                      <a class=" my_button " v-if="project.links.deployment" :href="project.links.deployment" target="_blank">View Website</a>
                      <br>
                      <a class=" my_button " v-if="project.links.github" :href="project.links.github" target="_blank">View Github</a>
                      <a class=" my_button " v-if="project.links.design" :href="project.links.design" target="_blank">View Design</a>
                    </div>
                    
                    
                  </div>
                </div>
                
              </div>
          </div>
        </section>
      </div>
    </section>

    <!-- Contact Me -->
    <section class="dark_background my_container center_me light_colour" id="anchor-contact">
      <h1 class="header padding_md light_underline ">Contact Me</h1>
    </section>

    <section class="dark_background padding_md light_colour">
      <div class=" ">

        <div class="my_container space_around">
          <div class="">
            <h1 class="header my_container center_me">Phone No.</h1>
            <p class="my_container contact_font center_me">(+353) 83 828 6822</p>
          </div>
          <div>
            <h1 class="header my_container center_me">Email</h1>
            <p class="my_container contact_font center_me">cjaygonzales117@gmail.com</p>
          </div>
          <div>
            <h1 class="header">Location</h1>
            <p class="my_container contact_font center_me">Co. Dublin, Ireland</p>
          </div>
        </div>
        <div class="my_container padding_bot_xxxlg padding_md space_around">
          <div>
            <h1 class="header my_container center_me">Github</h1>
            <p class="my_container contact_font center_me">https://github.com/CjayGonzales</p>
          </div>
          <div>
            <h1 class="header my_container center_me">Linked In</h1>
            <p class="my_container contact_font center_me">linkedin.com/in/clemente-gonzales-64686b211</p>
          </div>
          
        </div>

      </div>
      
    </section>
    
    


  </div>
</template>

<script>


export default {
  name: 'Home',
    data(){
    return{
      projects:[],
      searchTerm: ""
    } 
  },
  computed:{
    filteredProjects: function(){
      return this.projects.filter(project =>{
        return project.title.toLowerCase().includes(this.searchTerm.toLowerCase())

      })
    }
  },

  mounted(){
    this.getAllProjects();
  },

  methods:{

    getAllProjects(){

      fetch('./data/projects.json')
      .then(res => res.json())
      .then(data => {
        console.log(data)
        this.projects = data;
      })

    }

    
  }
}
</script>

<style>

html{
  scroll-behavior: smooth;
}

.skills_font{
  font-size: 40px;
  font-family: 'Playfair Display', serif;
  font-weight: lighter;
  color: #2A363B;
}

.contact_button{
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: lighter;
  background: #FFF4EB;
  color: #2A363B;
  font-size: 24px;
  padding-left: 20%;
  padding-right: 20%;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-bottom: 20px;
  text-decoration: none;
}

.contact_margin{
  margin-bottom: 40px;
}

.contact_button:hover{
  text-decoration: none;
}

.contact_font{
  font-size: 28px;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: lighter;
}

.image_width_and_height{
  width: 100%;
  height: 350px;
}

.card_width{
  width: 100%;
  height: 195px;
}

.my_button{
  margin: 25px 5px 5px 5px;
  padding: 6px 15px 6px 15px;
  background-color: #FFEEE1;
  color: #2A363B;
  text-decoration: none;
}

.fit_cover{
  object-fit: cover;
}

.background_dark{
  background-color: #2A363B;
}

.my_container{
  display: flex;
}

.center_me{
  justify-content: center;
}


.card_header{
  font-family: 'Playfair Display', serif;
  font-size: 48px;
  font-weight: 700;
}

.card_description{
  font-size: 20px;
  padding-top: 10px;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: lighter;
}

.red_background{
  background-color: #E84A5F;
}

.tag_font{
  font-size: 16px;
}

.light_color{
  color: #FFEEE1;
}

.shadow_me{
  box-shadow: 0px 8px 17px -6px rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 0px 8px 17px -6px rgba(0, 0, 0, 0.5);
}


.background_divider{
    background: linear-gradient(90deg, #2A363B 50%, #FFF4EB 50%);
}

.container_half{
  width: 50%;
  display: flex;
}

.container_smaller{
  width: 75%;
}

.center{
  justify-content: center;
}

.display_flex{
  display: flex;
}

.baseline{
  display: flex;
  align-items: baseline;
}



.space_between{
  justify-content: space-between;
}

.space_around{
  justify-content: space-around;
}

.more{
  font-size: 16px;
}

.aboutMe{
  font-size: 28px;
  font-weight: 200;

}

.aboutMe:hover{
  border-bottom: #FFEEE1;
  color: #FFF4EB;
}

.dark_background{
  background-color: #2A363B;
}

.light_backgroud{
  background-color: #FFF4EB;
}

.light_colour{
  color: #FFEEE1;
}

.dark_colour{
  color: #2A363B;
}

.header{
  font-family: 'Playfair Display', serif;
  font-size: 60px;
  font-weight: 700;
}

.secondary_header{
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 42px;
  font-weight: lighter;
}

.about_me{
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 22px;
  font-weight: lighter;
}

.skills{
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 24px;
  font-weight: lighter;
}

.skills_paragraph{
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 22px;
  font-weight: lighter;
}

.hero_image{
  height: 50%;
  width: 100%;

  /* Position and center the image to scale nicely on all screens */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;

}

.hero_text{
  position: absolute;
  top: 65%;
  left: 30%;
  transform: translate(-50%, -50%);
}

.light_underline{
    border-bottom: 4px solid #ffeee1;
}

.dark_underline{
    border-bottom: 4px solid #2A363B;
}



@keyframes slideInLeft{
  0%{
    transform: translateX(-100%);
  }
  100%{
    transform: translateX(0);
  }
  
}

.frontend_underline{
  border-bottom: 4px solid #E84A5F;
  width: 89%;
  line-height: 2;
}

.backend_underline{
  border-bottom: 4px solid #E84A5F;
  width: 65%;
  line-height: 2;
}

.ui_underline{
  border-bottom: 4px solid #E84A5F;
  width: 75%;
  line-height: 2;
}


section.is-inview backend_underline{
    animation: slideInLeft 20s infinite;
}



.projects_button{
  width: 200px;
  border-radius: 0;
}

.profile_image{
  width: 500px;
  height: 500px;
  object-fit: cover;
  box-shadow: 0px 12px 28px -10px rgba(0, 0, 0, 0.5);
-webkit-box-shadow: 0px 12px 28px -10px rgba(0, 0, 0, 0.5);
}

.margin_xsm{
  margin-top: 10px;
}

.margin_bot_md{
  margin-bottom: -30px;
}

.margin_sm{
  margin-top: 25px;
}

.margin_md{
  margin-top: 50px;
}

.margin_lg{
  margin-top: 100px;
}

.pad_left_right{
  padding-left: 30px;
  padding-right: 30px;
}

.padding_lg{
  padding-top: 100px;
}

.padding_xsm{
  padding-top: 10px;
}

.padding_sm{
  padding-top: 17px;
}



.padding_md{
  padding-top: 50px;
}

.padding_bot_lg{
  padding-bottom: 100px;
}

.margin_bot_lg{
  margin-bottom: 25px;
}

.padding_bot_xxxlg{
  padding-bottom: 300px;
}

</style>